import React from "react";
import { ENTRIES } from "../shared/assets/entry_data";
import { PAYOUTS } from "../shared/assets/payouts";
import { useLeaderboard } from "../shared/assets/useLeaderboard";
import { useIsFinal } from "../context/IsFinalContext";

function getPositionNum(golfer, golfers) {
    const g = golfers.find((obj) => obj.name === golfer);
    if (!g) return 99;
    if (g.status === "cut") return 55;
    return g.position ?? 99;
}

function getPlayerWinnings(golfer, golfers, isFinal) {
    const g = golfers.find((obj) => obj.name === golfer);
    if (!g) return 0;
    if (g.status === "cut") return 25000;
    if (isFinal) return g.winnings ?? 0;
    const pos = g.position;
    if (!pos || pos < 1) return 0;
    return PAYOUTS[pos - 1] ?? 0;
}

function entryComparator(a, b) {
    return a.name.localeCompare(b.name);
}

function Entries() {
    const { isFinal } = useIsFinal();
    const { golfers, lastUpdated, loading, error } = useLeaderboard();

    if (loading) return <p className="mt-20 text-center">Loading leaderboard...</p>;
    if (error)   return <p className="mt-20 text-center text-red-600">{error}</p>;

    const sortedEntries = [...ENTRIES].sort(entryComparator);

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
    });

    const entries = sortedEntries.map((entry) => {
        let golferLines = [];
        let totPos = 0;
        let totWinnings = 0;

        for (var i = 0; i < entry.golfers.length; i++) {
            const playerWinnings = getPlayerWinnings(entry.golfers[i], golfers, isFinal);
            totWinnings += playerWinnings;
            totPos += getPositionNum(entry.golfers[i], golfers);
            golferLines[i] = entry.golfers[i] + ' - ' + formatter.format(playerWinnings);
        }

        let avgPos = totPos / 5;
        let dollars = formatter.format(totWinnings);

        return (
            <div key={entry.name} id={entry.name}>
                <div className="m-5 w-64 shadow-2xl bg-gray-300 rounded-lg" key={entry.name}>
                    <div className="p-2 flex flex-col items-start">
                        <p className="text-2xl">{entry.name}</p>
                        <p className="text-base leading-9">Tot Winnings: {dollars}</p>
                        <p className="text-base leading-9">Avg Pos: {avgPos}</p>
                        <p className="text-sm">{golferLines[0]}</p>
                        <p className="text-sm">{golferLines[1]}</p>
                        <p className="text-sm">{golferLines[2]}</p>
                        <p className="text-sm">{golferLines[3]}</p>
                        <p className="text-sm">{golferLines[4]}</p>
                        <p className="text-sm leading-9">Tie-breaker: {entry.tiebreaker}</p>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <div className="mt-20">
            <p className="text-3xl mt-6 py-2 bg-masters-green masters-label">Entries</p>
            <div className="flex flex-row flex-wrap justify-center mb-6">{entries}</div>
            {lastUpdated && (
                <p className="text-center text-sm text-gray-500 mb-4">
                    Last updated: {new Date(lastUpdated).toLocaleTimeString()}
                </p>
            )}
        </div>
    );
}

export default Entries;